import React, { useContext, useState, useEffect } from "react";
import { Dialog, List, SwipeAction, Toast } from "antd-mobile";
import { Col, Form, Row } from "react-bootstrap";
import { Button } from "react-bootstrap";
import axios from "axios";
import PsContext from "../../context";
import { MOB_ICONS, momentDate, upperCase } from "../../utils";
import Header from "../header";
import WelcomeProfile from "../home/welcomeProfile";
import ModuleAccess from "../../context/moduleAccess";
import AddId from "./addid";
import { ServiceUrl } from "../../utils/serviceUrl";
import toast from "react-hot-toast";
import { APP_TYPE, baseUrl } from "../../utils";
import PsModalWindow from "../../utils/PsModalWindow";

const StudentIdCard = (props) => {
  const context = useContext(PsContext);
  const [showAdd, setShowAdd] = useState(false);
  const [profile, setProfile] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [loader, setLoader] = useState([]);

  /* useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    // setDataOption([]);
    const form = new FormData();
    form.append("registerno", context.user.registerno);
    axios.post(ServiceUrl.STUDENTS.LIST_ID_CARD, form).then((res) => {
      if (res["data"].status == "1") {
        setViewData(res["data"].data);
        console.log(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  }; */

  function downloadFile() {
    let registrationNumber = context.user.registerno;
    let link = `${baseUrl}mob/v1/idpdf?q=${registrationNumber}`;
    link += `&college_uuid=${context.user.college_uuid}`;
    link += `&college_short_name=${context.user.college_short_name}`;
    var a = document.createElement("a");
    a.setAttribute("download", registrationNumber);
    a.setAttribute("href", link);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  return (
    <>
      <Header title="Student Id Card" backAction={true} />
      <div className="page-content-wrapper">
        <div className="container py-2 px-0">
          <WelcomeProfile />
          <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
            <input
              type="hidden"
              name="registerno"
              value={context.user.registerno}
            />
            <input
              type="hidden"
              name="student_uuid"
              value={context.user.student_uuid}
            />
            <input
              type="hidden"
              name="college_uuid"
              value={context.user.college_uuid}
            />
            <Row className="mt-3">
              <Col md={10}>Student Id Card Download</Col>

              <Col md={2}>
                <li className="list-inline-item">
                  <Button
                    size="sm"
                    variant="primary"
                    className="border-start fs-6"
                    onClick={(e) => downloadFile()}
                  >
                    <i className="fa-solid fa-file-arrow-down"></i>
                  </Button>
                </li>
              </Col>
            </Row>
          </div>

          <div className="px-2">
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>Name</label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  value={`${context.user.name} ${context.user.initial || ""}`}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>Gender</label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  value={upperCase(context.user.gender)}
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={4} sm={4} xs={4}>
                <label>DOB</label>
              </Col>
              <Col md={8} sm={8} xs={8}>
                <Form.Control
                  type="text"
                  size="sm"
                  className="fw-bold"
                  value={momentDate(context.user.dob, "DD-MMM-YYYY")}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
      {/* <PsModalWindow
        size="md"
        show={showAdd}
        title="Add ID Card Details"
        onHide={(e) => setShowAdd(false)}
      >
        <AddId
          dataSource={viewData}
          onSuccess={(e) => {
            setShowAdd(false);
            loadData();
          }}
        />
      </PsModalWindow> */}
    </>
  );
};
export default StudentIdCard;
